import client from "./axiosConfig";

export const getUser = () => {
  const config = {
    url: "/users/",
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getAllUsers = (params) => {
  const config = {
    url: "/users/all/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const updateUserById = (data, params) => {
  const config = {
    url: "/users/",
    method: "PATCH",
    params,
    data
  };
  const response = client(config);
  return response;
};

export const reviewUserById = (data) => {
  const config = {
    url: "/users/review/",
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
}

export const getUserAccountInfo = (userId) => {
  const config = {
    url: `/users/account-info/${userId}/by-user/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const updateUserAccountInfo = (userId, data) => {
  const config = {
    url: `/users/account-info/${userId}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getUserDocuments = (params) => {
  const config = {
    url: "/users/documents/",
    method: "GET",
    params,
  };
  return client(config);
};

export const getUserDocumentsById = (id) => {
  const config = {
    url: `/users/documents/${id}`,
    method: "GET",
  };
  return client(config);
};

export const uploadDocument = (fileType, file, targetUserId = null) => {
  const formData = new FormData();
  formData.append("file_type", fileType);
  formData.append("file", file);
    if (targetUserId) {
      formData.append("user", targetUserId);
    }
    const config = {
      url: "/users/documents/",
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    return client(config);
};

export const updateDocumentStatus = (data) => {
  const config = {
    url: `/users/documents/update-status/`,
    method: "PATCH",
    data,
  };
  return client(config);
};


export const getUserDetailsById = (user_id) => {
  const config = {
    url: `/users/user/${user_id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const resetPasswordByHR = (data) => {
  const {id:user_id, ...body} = data;

  const config = {
    url: `/users/reset-password/${user_id}/`,
    method: "POST",
    data:body,
  };
  return client(config);
};